import React, { useContext, createContext } from 'react';
import { createClient } from '@supabase/supabase-js';
import type { ReactNode } from 'react';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

interface SupabaseProviderProps {
  children: ReactNode;
}

// Create a single instance of the Supabase client with a unique storage key
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'aquagenius_supabase_auth',
    autoRefreshToken: true,
    detectSessionInUrl: true,
    debug: true // Enable debug logging
  }
});

// Create context with a more specific type
interface SupabaseContextType {
  supabase: typeof supabase;
}

const SupabaseContext = createContext<SupabaseContextType | undefined>(undefined);

// Provider component
export const SupabaseProvider = ({ children }: SupabaseProviderProps) => {
  console.log('SupabaseProvider initializing');
  
  return (
    <SupabaseContext.Provider value={{ supabase }}>
      {children}
    </SupabaseContext.Provider>
  );
};

// Hook to use Supabase client
export const useSupabase = () => {
  const context = useContext(SupabaseContext);
  if (!context) {
    throw new Error('useSupabase must be used within a SupabaseProvider');
  }
  return context;
}; 